import { render, staticRenderFns } from "./threePage.vue?vue&type=template&id=fdc134ec&"
import script from "./threePage.vue?vue&type=script&lang=js&"
export * from "./threePage.vue?vue&type=script&lang=js&"
import style0 from "./threePage.vue?vue&type=style&index=0&id=fdc134ec&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports